import styled from "@emotion/styled";
import { Grid, Typography } from "@mui/material";
import { green } from "@mui/material/colors";
import { Box } from "@mui/system";
import { Fragment } from "react";
import SALES_RECORD_TYPE from "../../utils/variable";
import SalesDetailItem from "./SalesDetailItem";
import useDetailShortCut from "./hooks/useDetailShortcut";

const ListSalesDetailHeader = styled(Grid)({
  margin: 0,
  marginTop: 10,
  padding: 0,
  display: "flex",
  justifyContent: "center",
});

export default function SalesDetail(props) {
  const {
    salesDetails,
    apiSalesDetails,
    setting,
    insertedInvoice,
    ranks,
    productClasses,
    packings,
    renderState,
    changeHistoryItem,
    changeHistoryItemsWithArray
  } = props;
  const { salesRecordType } = setting.Value;
  const { handleKeyPress, handleKeyDown, focusNavigation } = useDetailShortCut({
    salesRecordType,
  });
  // console.log("Rerender time : ",getCountRerender());
  return (
    <Fragment>
      {/* 内容ヘッダー */}
      <ListSalesDetailHeader
        container
        sx={{ backgroundColor: green[100], borderRadius: 2 }}
      >
        <Grid item xs={1}>
          <Typography variant="h5" textAlign={"center"}>
            No.
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5" textAlign={"center"}>
            等級
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5" textAlign={"center"}>
            階級
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5" textAlign={"center"}>
            荷姿
          </Typography>
        </Grid>
        <Grid item xs={2}>
          <Typography variant="h5" textAlign={"center"}>
            量目ｇ
          </Typography>
        </Grid>
        <Grid item xs={1.5}>
          <Typography variant="h5" textAlign={"center"}>
            数量
          </Typography>
        </Grid>
        {salesRecordType !== SALES_RECORD_TYPE.LOCAL && (
          <Grid item xs={1.5}>
            <Typography variant="h5" textAlign={"center"}>
              仕入値
            </Typography>
          </Grid>
        )}
        {salesRecordType === SALES_RECORD_TYPE.LOCAL && (
          <Grid item xs={1.5}>
            <Typography variant="h5" textAlign={"center"}>
              内容明細
            </Typography>
          </Grid>
        )}
      </ListSalesDetailHeader>

      {/* 内容一覧 */}
      <Box onKeyPress={handleKeyPress} onKeyDown={handleKeyDown}>
        {salesDetails.Value.map((salesDetail, index) => {
          return (
            <SalesDetailItem
              key={`$salesDetail-${salesDetail.salesDetailNo}`}
              salesDetail={salesDetail}
              apiSalesDetails={apiSalesDetails}
              index={index}
              ranks={ranks}
              productClasses={productClasses}
              packings={packings}
              focusNavigation={focusNavigation}
              salesRecordType={salesRecordType}
              insertedInvoice={insertedInvoice}
              renderState={renderState}
              setting={setting}
              updateIndexProp={salesDetails.updateIndexProp}
              changeHistoryItem={changeHistoryItem}
              changeHistoryItemsWithArray={changeHistoryItemsWithArray}
            />
          );
        })}
      </Box>
    </Fragment>
  );
}
